import { BaseIdRequiredRequest } from "../../../../base/request/BaseIdRequiredRequest";
import { ClienteFincaBaseResponse } from "../../../terceros/response/ClienteFincaBaseResponse";

/** Request de configuración de ganadería de una finca (`POST
 *  /configuracion/fincas-ganaderia/save`). `id` = id de la finca (siempre
 *  presente: se configura una finca existente). Se crea con
 *  `fx_createFincaGanaderiaRequest()` precargando los valores de la finca. */
export type FincaGanaderiaRequest = BaseIdRequiredRequest & {
  /** Crecimiento diario óptimo esperado (g/día). */
  ganaderiaCrecimientoDiarioGr: number;

  /** Días de descanso óptimo de un potrero. */
  ganaderiaDiasDescansoOptimo: number;

  /** Días de ocupación óptimo de un potrero. */
  ganaderiaDiasOcupacionOptimo: number;

  /** Carga animal óptima (animales por hectárea), usada como referencia por
   *  defecto para los lotes de la finca. Requerido por el server. */
  ganaderiaAnimalesXHectareaOptimo: number;
};

export const fx_createFincaGanaderiaRequest = (
  finca: ClienteFincaBaseResponse,
): FincaGanaderiaRequest => {
  return {
    id: finca.id,
    ganaderiaCrecimientoDiarioGr: finca.ganaderiaCrecimientoDiarioGr,
    ganaderiaDiasDescansoOptimo: finca.ganaderiaDiasDescansoOptimo,
    ganaderiaDiasOcupacionOptimo: finca.ganaderiaDiasOcupacionOptimo,
    ganaderiaAnimalesXHectareaOptimo: finca.ganaderiaAnimalesXHectareaOptimo,
  };
};
